// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.InternalInvoiceForm-module_root___dKNYm {
  width: 960px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
}
.theme--light .InternalInvoiceForm-module_root___dKNYm {
  background-color: #ffffff;
}
.theme--dark .InternalInvoiceForm-module_root___dKNYm {
  background-color: #1c1c1c;
}

.InternalInvoiceForm-module_body___ULPTN {
  display: flex;
  padding: 1.6rem 0;
}
@media (max-width: 820px) {
  .InternalInvoiceForm-module_body___ULPTN {
    flex-direction: column;
  }
}

.InternalInvoiceForm-module_colTitle___Gbhai {
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1.6rem;
}
.theme--light .InternalInvoiceForm-module_colTitle___Gbhai {
  color: #212121;
}
.theme--dark .InternalInvoiceForm-module_colTitle___Gbhai {
  color: #f0f0f0;
}

.InternalInvoiceForm-module_mainCol___xqIhC {
  flex: 1;
  min-width: 320px;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.InternalInvoiceForm-module_field___mMRQa {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.InternalInvoiceForm-module_fieldLabel___BWJe5 {
  font-size: 1.4rem;
  font-weight: 500;
}
.theme--light .InternalInvoiceForm-module_fieldLabel___BWJe5 {
  color: #212121;
}
.theme--dark .InternalInvoiceForm-module_fieldLabel___BWJe5 {
  color: #f0f0f0;
}

.InternalInvoiceForm-module_required___cYbfP {
  color: #ff8e58;
}

.InternalInvoiceForm-module_twoCol___YTF7b {
  display: flex;
  gap: 1.2rem;
}
.InternalInvoiceForm-module_twoCol___YTF7b > * {
  flex: 1;
}

.InternalInvoiceForm-module_input___s82NU {
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 1.4rem;
  width: 100%;
}
.theme--light .InternalInvoiceForm-module_input___s82NU {
  border: 1px solid #dddddd;
  color: #212121;
}
.theme--dark .InternalInvoiceForm-module_input___s82NU {
  border: 1px solid #2f2f2f;
  color: #f0f0f0;
}

.InternalInvoiceForm-module_input___s82NU:disabled {
  cursor: not-allowed;
}
.theme--light .InternalInvoiceForm-module_input___s82NU:disabled {
  background-color: #dddddd;
  color: #888888;
}
.theme--dark .InternalInvoiceForm-module_input___s82NU:disabled {
  background-color: #2f2f2f;
  color: #a3a3a3;
}

.InternalInvoiceForm-module_textarea___jfKQq {
  padding: 8px 10px;
  border-radius: 4px;
  font-size: 1.3rem;
  min-height: 80px;
  resize: vertical;
  width: 100%;
}
.theme--light .InternalInvoiceForm-module_textarea___jfKQq {
  border: 1px solid #dddddd;
  color: #212121;
}
.theme--dark .InternalInvoiceForm-module_textarea___jfKQq {
  border: 1px solid #2f2f2f;
  color: #f0f0f0;
}

.InternalInvoiceForm-module_customerDropdown___GalEX div[class*=itemsContainer] {
  max-height: 180px;
  overflow-y: auto;
}

.InternalInvoiceForm-module_seatList___X7nBr {
  display: flex;
  flex-direction: column;
  max-height: 220px;
  overflow-y: auto;
  border-radius: 6px;
}
.theme--light .InternalInvoiceForm-module_seatList___X7nBr {
  border: 1px solid #dddddd;
}
.theme--dark .InternalInvoiceForm-module_seatList___X7nBr {
  border: 1px solid #2f2f2f;
}

.InternalInvoiceForm-module_seatRow___IPmMu {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  font-size: 1.4rem;
  cursor: pointer;
}
.theme--light .InternalInvoiceForm-module_seatRow___IPmMu {
  border-bottom: 1px solid #dddddd;
  color: #212121;
}
.theme--dark .InternalInvoiceForm-module_seatRow___IPmMu {
  border-bottom: 1px solid #2f2f2f;
  color: #f0f0f0;
}

.InternalInvoiceForm-module_seatRow___IPmMu:last-child {
  border-bottom: none;
}

.InternalInvoiceForm-module_emptySeats___SYg_r {
  font-size: 1.2rem;
}
.theme--light .InternalInvoiceForm-module_emptySeats___SYg_r {
  color: #888888;
}
.theme--dark .InternalInvoiceForm-module_emptySeats___SYg_r {
  color: #a3a3a3;
}

.InternalInvoiceForm-module_refCol___uBZNd {
  min-width: 220px;
  max-width: 260px;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}
.theme--light .InternalInvoiceForm-module_refCol___uBZNd {
  border-left: 1px solid #dddddd;
}
.theme--dark .InternalInvoiceForm-module_refCol___uBZNd {
  border-left: 1px solid #2f2f2f;
}
@media (max-width: 820px) {
  .InternalInvoiceForm-module_refCol___uBZNd {
    border-left: none;
    max-width: none;
  }
}

.InternalInvoiceForm-module_refBlock___TRfp5 {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.InternalInvoiceForm-module_refLabel___Z22RH {
  font-size: 1.2rem;
}
.theme--light .InternalInvoiceForm-module_refLabel___Z22RH {
  color: #888888;
}
.theme--dark .InternalInvoiceForm-module_refLabel___Z22RH {
  color: #a3a3a3;
}

.InternalInvoiceForm-module_refValue___Smqe4 {
  font-size: 1.6rem;
  font-weight: 600;
}
.theme--light .InternalInvoiceForm-module_refValue___Smqe4 {
  color: #212121;
}
.theme--dark .InternalInvoiceForm-module_refValue___Smqe4 {
  color: #f0f0f0;
}

.InternalInvoiceForm-module_refNotes___sEuBb {
  font-size: 1.3rem;
  word-break: break-word;
}
.theme--light .InternalInvoiceForm-module_refNotes___sEuBb {
  color: #212121;
}
.theme--dark .InternalInvoiceForm-module_refNotes___sEuBb {
  color: #f0f0f0;
}

.InternalInvoiceForm-module_footer___CGe2R {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  padding: 1.6rem 2rem;
}
.theme--light .InternalInvoiceForm-module_footer___CGe2R {
  border-top: 1px solid #dddddd;
}
.theme--dark .InternalInvoiceForm-module_footer___CGe2R {
  border-top: 1px solid #2f2f2f;
}

.InternalInvoiceForm-module_complete___Noj1v {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 1.4rem;
}
.theme--light .InternalInvoiceForm-module_complete___Noj1v {
  color: #212121;
}
.theme--dark .InternalInvoiceForm-module_complete___Noj1v {
  color: #f0f0f0;
}

.InternalInvoiceForm-module_buttons___VOHpN {
  display: flex;
  gap: 1.2rem;
}

.InternalInvoiceForm-module_pdfRoot___b3eJg {
  width: 900px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
}
.theme--light .InternalInvoiceForm-module_pdfRoot___b3eJg {
  background-color: #ffffff;
}
.theme--dark .InternalInvoiceForm-module_pdfRoot___b3eJg {
  background-color: #1c1c1c;
}

.InternalInvoiceForm-module_pdfHeader___w485X {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 2rem;
  font-size: 1.4rem;
  font-weight: 600;
}
.theme--light .InternalInvoiceForm-module_pdfHeader___w485X {
  border-bottom: 1px solid #dddddd;
  color: #212121;
}
.theme--dark .InternalInvoiceForm-module_pdfHeader___w485X {
  border-bottom: 1px solid #2f2f2f;
  color: #f0f0f0;
}

.InternalInvoiceForm-module_pdfViewer___CYz1w {
  width: 100%;
  height: 75vh;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/components/internalInvoiceForm/InternalInvoiceForm.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AAmBD;AD+EE;EC/FA,yBAAA;AAmBF;AD4EE;EC/FA,yBAAA;AAsBF;;AAlBA;EACC,aAAA;EACA,iBAAA;AAqBD;AAnBC;EAJD;IAKE,sBAAA;EAsBA;AACF;;AAnBA;EAIC,iBAAA;EACA,gBAAA;EACA,qBAAA;AAmBD;ADyDE;EChFA,cAAA;AA0BF;ADsDE;EChFA,cAAA;AA6BF;;AAtBA;EACC,OAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAyBD;;AAtBA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAyBD;;AAtBA;EAIC,iBAAA;EACA,gBAAA;AAsBD;AD+BE;ECxDA,cAAA;AA4BF;AD4BE;ECxDA,cAAA;AA+BF;;AAzBA;EACC,cAAA;AA4BD;;AAzBA;EACC,aAAA;EACA,WAAA;AA4BD;AA1BC;EACC,OAAA;AA4BF;;AAxBA;EAMC,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAsBD;ADME;ECnCA,yBAAA;EAEA,cAAA;AA+BF;ADEE;ECnCA,yBAAA;EAEA,cAAA;AAmCF;;AA3BA;EAKC,mBAAA;AA0BD;ADNE;ECvBA,yBAAA;EACA,cAAA;AAgCF;ADVE;ECvBA,yBAAA;EACA,cAAA;AAoCF;;AA/BA;EAMC,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AA6BD;ADvBE;ECfA,yBAAA;EAEA,cAAA;AAwCF;AD3BE;ECfA,yBAAA;EAEA,cAAA;AA4CF;;AAjCC;EACC,iBAAA;EACA,gBAAA;AAoCF;;AAhCA;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EAKA,kBAAA;AA+BD;AD5CE;ECWA,yBAAA;AAoCF;AD/CE;ECWA,yBAAA;AAuCF;;AAlCA;EAKC,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AAiCD;AD3DE;ECkBA,gCAAA;EACA,cAAA;AA4CF;AD/DE;ECkBA,gCAAA;EACA,cAAA;AAgDF;;AAtCA;EACC,mBAAA;AAyCD;;AAtCA;EAIC,iBAAA;AAsCD;AD3EE;ECmCA,cAAA;AA2CF;AD9EE;ECmCA,cAAA;AA8CF;;AAzCA;EAIC,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAyCD;AD1FE;EC0CA,8BAAA;AAmDF;AD7FE;EC0CA,8BAAA;AAsDF;AA7CC;EAXD;IAYE,iBAAA;IACA,eAAA;EAgDA;AACF;;AA7CA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AAgDD;;AA7CA;EAIC,iBAAA;AA6CD;ADhHE;ECiEA,cAAA;AAkDF;ADnHE;ECiEA,cAAA;AAqDF;;AAhDA;EAIC,iBAAA;EACA,gBAAA;AAgDD;AD3HE;ECwEA,cAAA;AAsDF;AD9HE;ECwEA,cAAA;AAyDF;;AAnDA;EAIC,iBAAA;EACA,sBAAA;AAmDD;ADtIE;ECgFA,cAAA;AAyDF;ADzIE;ECgFA,cAAA;AA4DF;;AAtDA;EAIC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,oBAAA;AAsDD;ADpJE;ECwFA,6BAAA;AA+DF;ADvJE;ECwFA,6BAAA;AAkEF;;AAzDA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;AA4DD;ADlKE;ECyGA,cAAA;AA4DF;ADrKE;ECyGA,cAAA;AA+DF;;AA3DA;EACC,aAAA;EACA,WAAA;AA8DD;;AA3DA;EACC,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AA8DD;ADpLE;ECyHA,yBAAA;AA8DF;ADvLE;ECyHA,yBAAA;AAiEF;;AA7DA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EAMA,iBAAA;EACA,gBAAA;AA2DD;ADnME;ECoIA,gCAAA;EACA,cAAA;AAkEF;ADvME;ECoIA,gCAAA;EACA,cAAA;AAsEF;;AAhEA;EACC,WAAA;EACA,YAAA;EACA,YAAA;AAmED","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.root {\n  width: 960px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n:global(.theme--light) .root {\n  background-color: #ffffff;\n}\n:global(.theme--dark) .root {\n  background-color: #1c1c1c;\n}\n\n.body {\n  display: flex;\n  padding: 1.6rem 0;\n}\n@media (max-width: 820px) {\n  .body {\n    flex-direction: column;\n  }\n}\n\n.colTitle {\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 1.6rem;\n}\n:global(.theme--light) .colTitle {\n  color: #212121;\n}\n:global(.theme--dark) .colTitle {\n  color: #f0f0f0;\n}\n\n.mainCol {\n  flex: 1;\n  min-width: 320px;\n  padding: 0 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.fieldLabel {\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n:global(.theme--light) .fieldLabel {\n  color: #212121;\n}\n:global(.theme--dark) .fieldLabel {\n  color: #f0f0f0;\n}\n\n.required {\n  color: #ff8e58;\n}\n\n.twoCol {\n  display: flex;\n  gap: 1.2rem;\n}\n.twoCol > * {\n  flex: 1;\n}\n\n.input {\n  padding: 8px 10px;\n  border-radius: 4px;\n  font-size: 1.4rem;\n  width: 100%;\n}\n:global(.theme--light) .input {\n  border: 1px solid #dddddd;\n  color: #212121;\n}\n:global(.theme--dark) .input {\n  border: 1px solid #2f2f2f;\n  color: #f0f0f0;\n}\n\n.input:disabled {\n  cursor: not-allowed;\n}\n:global(.theme--light) .input:disabled {\n  background-color: #dddddd;\n  color: #888888;\n}\n:global(.theme--dark) .input:disabled {\n  background-color: #2f2f2f;\n  color: #a3a3a3;\n}\n\n.textarea {\n  padding: 8px 10px;\n  border-radius: 4px;\n  font-size: 1.3rem;\n  min-height: 80px;\n  resize: vertical;\n  width: 100%;\n}\n:global(.theme--light) .textarea {\n  border: 1px solid #dddddd;\n  color: #212121;\n}\n:global(.theme--dark) .textarea {\n  border: 1px solid #2f2f2f;\n  color: #f0f0f0;\n}\n\n.customerDropdown div[class*=itemsContainer] {\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.seatList {\n  display: flex;\n  flex-direction: column;\n  max-height: 220px;\n  overflow-y: auto;\n  border-radius: 6px;\n}\n:global(.theme--light) .seatList {\n  border: 1px solid #dddddd;\n}\n:global(.theme--dark) .seatList {\n  border: 1px solid #2f2f2f;\n}\n\n.seatRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  font-size: 1.4rem;\n  cursor: pointer;\n}\n:global(.theme--light) .seatRow {\n  border-bottom: 1px solid #dddddd;\n  color: #212121;\n}\n:global(.theme--dark) .seatRow {\n  border-bottom: 1px solid #2f2f2f;\n  color: #f0f0f0;\n}\n\n.seatRow:last-child {\n  border-bottom: none;\n}\n\n.emptySeats {\n  font-size: 1.2rem;\n}\n:global(.theme--light) .emptySeats {\n  color: #888888;\n}\n:global(.theme--dark) .emptySeats {\n  color: #a3a3a3;\n}\n\n.refCol {\n  min-width: 220px;\n  max-width: 260px;\n  padding: 0 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n}\n:global(.theme--light) .refCol {\n  border-left: 1px solid #dddddd;\n}\n:global(.theme--dark) .refCol {\n  border-left: 1px solid #2f2f2f;\n}\n@media (max-width: 820px) {\n  .refCol {\n    border-left: none;\n    max-width: none;\n  }\n}\n\n.refBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.refLabel {\n  font-size: 1.2rem;\n}\n:global(.theme--light) .refLabel {\n  color: #888888;\n}\n:global(.theme--dark) .refLabel {\n  color: #a3a3a3;\n}\n\n.refValue {\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n:global(.theme--light) .refValue {\n  color: #212121;\n}\n:global(.theme--dark) .refValue {\n  color: #f0f0f0;\n}\n\n.refNotes {\n  font-size: 1.3rem;\n  word-break: break-word;\n}\n:global(.theme--light) .refNotes {\n  color: #212121;\n}\n:global(.theme--dark) .refNotes {\n  color: #f0f0f0;\n}\n\n.footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.2rem;\n  padding: 1.6rem 2rem;\n}\n:global(.theme--light) .footer {\n  border-top: 1px solid #dddddd;\n}\n:global(.theme--dark) .footer {\n  border-top: 1px solid #2f2f2f;\n}\n\n.complete {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 1.4rem;\n}\n:global(.theme--light) .complete {\n  color: #212121;\n}\n:global(.theme--dark) .complete {\n  color: #f0f0f0;\n}\n\n.buttons {\n  display: flex;\n  gap: 1.2rem;\n}\n\n.pdfRoot {\n  width: 900px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n:global(.theme--light) .pdfRoot {\n  background-color: #ffffff;\n}\n:global(.theme--dark) .pdfRoot {\n  background-color: #1c1c1c;\n}\n\n.pdfHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.2rem 2rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n}\n:global(.theme--light) .pdfHeader {\n  border-bottom: 1px solid #dddddd;\n  color: #212121;\n}\n:global(.theme--dark) .pdfHeader {\n  border-bottom: 1px solid #2f2f2f;\n  color: #f0f0f0;\n}\n\n.pdfViewer {\n  width: 100%;\n  height: 75vh;\n  border: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `InternalInvoiceForm-module_root___dKNYm`,
	"body": `InternalInvoiceForm-module_body___ULPTN`,
	"colTitle": `InternalInvoiceForm-module_colTitle___Gbhai`,
	"mainCol": `InternalInvoiceForm-module_mainCol___xqIhC`,
	"field": `InternalInvoiceForm-module_field___mMRQa`,
	"fieldLabel": `InternalInvoiceForm-module_fieldLabel___BWJe5`,
	"required": `InternalInvoiceForm-module_required___cYbfP`,
	"twoCol": `InternalInvoiceForm-module_twoCol___YTF7b`,
	"input": `InternalInvoiceForm-module_input___s82NU`,
	"textarea": `InternalInvoiceForm-module_textarea___jfKQq`,
	"customerDropdown": `InternalInvoiceForm-module_customerDropdown___GalEX`,
	"seatList": `InternalInvoiceForm-module_seatList___X7nBr`,
	"seatRow": `InternalInvoiceForm-module_seatRow___IPmMu`,
	"emptySeats": `InternalInvoiceForm-module_emptySeats___SYg_r`,
	"refCol": `InternalInvoiceForm-module_refCol___uBZNd`,
	"refBlock": `InternalInvoiceForm-module_refBlock___TRfp5`,
	"refLabel": `InternalInvoiceForm-module_refLabel___Z22RH`,
	"refValue": `InternalInvoiceForm-module_refValue___Smqe4`,
	"refNotes": `InternalInvoiceForm-module_refNotes___sEuBb`,
	"footer": `InternalInvoiceForm-module_footer___CGe2R`,
	"complete": `InternalInvoiceForm-module_complete___Noj1v`,
	"buttons": `InternalInvoiceForm-module_buttons___VOHpN`,
	"pdfRoot": `InternalInvoiceForm-module_pdfRoot___b3eJg`,
	"pdfHeader": `InternalInvoiceForm-module_pdfHeader___w485X`,
	"pdfViewer": `InternalInvoiceForm-module_pdfViewer___CYz1w`
};
export default ___CSS_LOADER_EXPORT___;
